import React from 'react';
const CARDS = [{
  title: 'Broken Window Glass',
  copy: "A broken home window can affect safety, comfort and curb appeal. Kosin's Glass can replace cracked, shattered or damaged glass and help restore your window's clear view."
}, {
  title: 'Foggy Double-Pane Glass',
  copy: "Condensation or cloudiness between panes usually points to a failed insulated-glass seal. Kosin's Glass can inspect the unit and recommend the right repair or replacement option."
}, {
  title: 'Insulated & Low-E Glass',
  copy: 'Ask about insulated glass and Low-E glass replacement options that may help improve comfort and reduce heat transfer compared with older or damaged glass.'
}];
export function ProblemSolution() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 text-white" data-id="element-1242" data-mp="1wgb1lotdsmln">
      <div className="max-w-7xl mx-auto" data-id="element-1243" data-mp="3lvim6f1tleki">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1244" data-mp="3qu26kb0rmiar">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-normal mb-6" data-id="element-1245" data-mp="3qtaom303cj2y">
            Broken, Cracked or Foggy Window Glass?
          </h2>
        </div>
        <ul className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-1246" data-mp="2wdh1ry6i0q2h">
          {CARDS.map((card, idx) => <li key={idx} className="bg-navy-800 rounded-lg p-8 border border-navy-700 anim-on-scroll" data-id="element-1247" data-mp="3a3asyn5h7mfd" data-mpi={idx}>
              <h3 className="text-2xl font-bold mb-4 text-brandBlue-400" data-id="element-1248" data-mp="357c8vbr6kqkr">
                {card.title}
              </h3>
              <p className="text-slate-300 leading-relaxed" data-id="element-1249" data-mp="2decxf2pwjkh5">{card.copy}</p>
            </li>)}
        </ul>
        <div className="text-center" data-id="element-1250" data-mp="2ree08npq91z9">
          <a href="#quote" className="inline-flex items-center justify-center bg-brandBlue-600 hover:bg-brandBlue-500 text-white font-bold text-lg py-4 px-8 rounded-lg transition-colors shadow-md" data-id="element-1251" data-mp="2rfflfl0gj4up">
            Request a Window Glass Quote
          </a>
        </div>
      </div>
    </section>;
}